import type { LabelHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  children: ReactNode;
}

export function Label({ required, className, children, ...rest }: LabelProps) {
  return (
    <label className={cn('field-label', className)} {...rest}>
      {children}
      {required && (
        <span className="ml-1 text-danger" aria-hidden>
          *
        </span>
      )}
    </label>
  );
}
